import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import Modal from '@components/modal/modal'
import Button from '@components/button/button'
import { BoxButton, BoxCrop } from './style'

const ModalCrop = ({ isOpened, setImageCropped, fileUploaded, onModalClose }) => {
  const cropperRef = useRef()
  const getCropData = () => {
    const imageElement = cropperRef?.current
    const cropper = imageElement?.cropper
    setImageCropped(cropper.getCroppedCanvas().toDataURL())
  }

  return (
    <Modal title="Ajuste sua imagem" isOpened={isOpened} onClose={onModalClose}>
      <p>
        Você pode ajustar o zoom através do <em>scroll do mouse</em>.
      </p>
      <BoxCrop>
        <Cropper src={fileUploaded} style={{ height: 250, width: 250 }} initialAspectRatio={1 / 1} guides={true} ref={cropperRef} />
      </BoxCrop>

      <BoxButton>
        <Button id="crop-button" icon="right" theme="primary" onClick={getCropData}>
          cortar
        </Button>
      </BoxButton>
    </Modal>
  )
}
ModalCrop.displayName = 'ModalCrop'
ModalCrop.propTypes = {
  isOpened: PropTypes.bool,
  setImageCropped: PropTypes.func,
  fileUploaded: PropTypes.string,
  onModalClose: PropTypes.func,
}

export default ModalCrop
